import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import Footer from "./Pages/Footer";
import {
  getCurrentGoldPrice,
  getGoldPriceHistory,
} from "./services/gold-price";
import PriceBox from "./Pages/Dashboard/PriceBox";
import { getCurrentReport, getSystemContents } from "./services/statistics";
import { getCommoditiesList } from "./services/commodities";
import { Line } from "react-chartjs-2";
import { toast } from "react-toastify";
import Products from "./components/Products";
import { toPersianNum } from "./utils/persianNumbers";
import { getUserChannels } from "./services/vod/vod.service";

export default function Home() {
  const [activatePopup, setActivatePopup] = useState(false);
  const [showPermissionBtn, setShowPermissionBtn] = useState(true);
  const [activeChart, setActiveChart] = useState("buy");
  const [buyValues, setBuyValues] = useState([]);
  const [sellValues, setSellValues] = useState([]);
  const [labels, setLabels] = useState([]);
  const [commodities, setCommodities] = useState([]);
  const [selectedCommodity, setSelectedCommodity] = useState("1");
  const [selectedChart, setSelectedChart] = useState(1);
  const [prices, setPrices] = useState({});
  const [active, setActive] = useState("buy");
  const [chartColor, setChartColor] = useState(null);
  const [soat, setSoat] = useState(0);
  const [gram, setGram] = useState(0);
  const [amount, setamount] = useState(0);
  const [gramPriceBuy, setGramPriceBuy] = useState(100000);
  const [soatPriceBuy, setSoatPriceBuy] = useState(20000);
  const [gramPriceSell, setGramPriceSell] = useState(100000);
  const [soatPriceSell, setSoatPriceSell] = useState(20000);
  const [sellVariation, setSellVariation] = useState(0);
  const [buyVariation, setBuyVariation] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [usersNumber, setUsersNumber] = useState(0);
  const [tradesNumber, setTradesNumber] = useState(0);
  const [lastChange, setLastChange] = useState("");
  const [landingContent, setLandingContent] = useState([]);
  const [iframeLink, setIframeLink] = useState("");
  const [sellImage, setSellImage] = useState("");
  const [buyImage, setBuyImage] = useState("");
  const [footerImage, setFooterImage] = useState("");
  const [sellTitle, setSellTitle] = useState("");
  const [buyTitle, setBuyTitle] = useState("");
  const [footerTitle, setFooterTitle] = useState("");
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 769px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const tmpTheme = process.env.REACT_APP_TEMP_THEME;
  const handlePermissionRequest = () => {
    try {
      Notification.requestPermission().then(() => {});
    } catch (e) {}
  };
  useEffect(() => {
    setSoat(0);
    setGram(0);
    setamount(0);
    getCurrentGoldPrice(selectedCommodity?.id).then((res) => {
      if (res.status == 200) {
        let data = res?.data;
        if (data && data?.data) {
          setPrices(data?.data);
          setGramPriceBuy(data?.data?.buy_price?.gram);
          setGramPriceSell(data?.data?.sell_price?.gram);
          setSoatPriceBuy(data?.data?.buy_price?.soot);
          setSoatPriceSell(data?.data?.sell_price?.soot);
          setSellVariation(data?.data?.sell_price?.variation_percent);
          setBuyVariation(data.data.buy_price?.variation_percent);
        }
      }
    });
  }, [selectedCommodity.id]);
  const showActiveNotif = () => {
    toast.success("اعلانات شما فعال شد");
  };
  useEffect(() => {
    async function fetchData() {
      const res = await getCommoditiesList();
      if (res?.status === 200) {
        const data = res?.data?.results;
        if (data) {
          setCommodities(data);
          setSelectedCommodity(data[0]);
        }
      }
    }

    fetchData();

    try {
      if (
        Notification?.permission === "granted" ||
        Notification?.permission === "denied"
      ) {
        setShowPermissionBtn(false);
      } else {
        setShowPermissionBtn(true);
      }
    } catch (e) {
      console.error("Notification permission check failed:", e);
    }

    try {
      if ("permissions" in navigator && navigator.permissions?.query) {
        navigator.permissions
          .query({ name: "notifications" })
          .then((permStatus) => {
            permStatus.onchange = () => {
              const permission = Notification?.permission;
              if (permission === "granted") {
                showActiveNotif();
                setShowPermissionBtn(false);
              } else if (permission === "denied") {
                setShowPermissionBtn(false);
              } else {
                setShowPermissionBtn(true);
              }
            };
          })
          .catch((err) => {
            console.warn("Permissions query failed:", err);
          });
      }
    } catch (e) {
      console.warn("Permissions block error:", e);
    }
  }, []);

  useEffect(() => {
    if (selectedChart && !isNaN(selectedChart)) {
      getGoldPriceHistory(selectedChart)
        .then((res) => {
          if (res.status == 200) {
            if (res && res.data && res.data.results) {
              const tmpLabels = (res?.data?.results || []).map(
                (item) => (item?.created_at || "").split("T")[0]
              );
              const bValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              const sValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              setBuyValues(bValues);
              setSellValues(sValues);
              setLabels(tmpLabels);
            }
          } else {
            toast.error(res?.data?.detail);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.detail);
        });
    }
  }, [selectedChart]);
  useEffect(() => {
    const selectedCommodityChart = commodities.find(
      (el) => el.id == selectedChart
    );
    if (selectedCommodityChart) {
      setChartColor(selectedCommodityChart?.ui_data?.colors?.primary);
    }
  }, [commodities, selectedChart]);
  useEffect(() => {
    function fetchData() {
      getCurrentReport().then((res) => {
        if (res.status == 200) {
          let data = res.data;

          if (data && data.data) {
            setUsersNumber(data.data.registered_users_number);
            setTradesNumber(data.data.trades_number);
          }
        }
      });
      getSystemContents().then((res) => {
        if (res.status == 200) {
          let data = res?.data?.results;
          if (data) {
            setLandingContent(data);
            data.map((item) =>
              item.key === "banner_link" ? setIframeLink(item.value) : null
            );
            data.map((item) =>
              item.key === "sell_gold_image" ? setSellImage(item.value) : null
            );
            data.map((item) =>
              item.key === "sell_gold_title" ? setSellTitle(item.value) : null
            );
            data.map((item) =>
              item.key === "buy_gold_image" ? setBuyImage(item.value) : null
            );
            data.map((item) =>
              item.key === "buy_gold_title" ? setBuyTitle(item.value) : null
            );
            data.map((item) =>
              item.key === "footer_image" ? setFooterImage(item.value) : null
            );
            data.map((item) =>
              item.key === "footer_title" ? setFooterTitle(item.value) : null
            );
          }
        }
      });
    }
    fetchData();
  }, []);

  function handleValueChange(event) {
    let p = event.target.value;
    let name = event.target.name;

    if (p < 0) {
      return;
    }

    if (!p) {
      p = 0;
    }

    if (name == "gram") {
      let value = parseInt(p);
      setGram(value);
    }

    if (name == "soat") {
      let value = parseInt(p);

      if (value > 999) {
        return;
      }
      setSoat(value);
    }
  }
  function handleCalculation() {
    const activePrice = active === "buy" ? gramPriceBuy : gramPriceSell;
    if (lastChange === "amount") {
      const convertToWeight = amount / activePrice;
      setSoat(parseInt((convertToWeight % 1) * 1000));
      setGram(parseInt(convertToWeight) || 0);
    } else {
      let res = null;
      res = (Number(gram) + Number(soat / 1000)) * Number(activePrice);
      setamount(Math.round(res));
    }
  }

  function separateNum(value) {
    var nStr = value + "";
    nStr = nStr.replace(/\,/g, "");
    let x = nStr.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }

  return (
    <div>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
                  "@type": "Corporation",
                  "name": "talaeshow",
                  "url": "https://talaeshow.com/",
                  "description":"talaeshow is a store that's for selling, buying and remaining Gold Bullion for all people. ",
                  "logo": "https://talaeshow.com/main_logo.svg",
                  "sameAs":["https://instagram.com/talae.show","https://www.linkedin.com/company/talaeshow/","https://t.me/talaeshow","https://twitter.com/talaeshow","https://www.aparat.com/talaeshow"],
                  "contactPoint": [
                    {
                        "@type":"PostalAddress","addressLocality":"Tehran","streetAddress":"Heravi Square, Forud street",
                        "addressCountry":{"@type":"country","name":"Iran"}
                    }                
                 ]  
              } 
          `}
        </script>
      </Helmet>
      {isDesktopOrLaptop && (
        <div className="landing">
          <header className="header-wrap">
            <div className="border-item">
              <img src={"/images/svg/border.svg"} alt={""} />
            </div>
            <div className="header-wrap-container">
              <div className="header-wrap-right">
                <div className="pattern-and-shadow-right">
                  <div>
                    <img src={"/images/svg/right-pattern.svg"} alt="" />
                  </div>
                  <div>
                    <img src={"/images/svg/shadow-right.svg"} alt="" />
                  </div>
                </div>
                <div className="content-landing-header">
                  {tmpTheme != 1 ? (
                    <h1 className="landing-header-title">
                      خرید و فروش شمش طلا و نقره؛
                      <br />
                      سرمایه‌گذاری در طلا و نقره با هر میزان بودجه
                    </h1>
                  ) : (
                    <h1 className="landing-header-title">
                      خرید آنلاین شمش طلا و نقره از طلایی شو
                    </h1>
                  )}
                  <div className="logo-landing">
                    <img src={"/images/svg/landing-logo.svg"} alt={""} />
                  </div>
                  {tmpTheme != 1 ? (
                    <h1 className="landing-header-subtitle">
                      خرید شمش طلا و نقره را اینجا تجربه کنید!
                      <br />
                      از یک گرم تا چند کیلو طلا و نقره بخرید و پس انداز با
                      <br />
                      فلزات گرانبها را شروع کنید. (با کمترین کارمزد)
                    </h1>
                  ) : (
                    <h1 className="landing-header-subtitle">
                      با امکان تحویل حضوری و ارسال پستی
                    </h1>
                  )}
                  {tmpTheme != 1 ? (
                    <div className="landing-fast-start">
                      <Link to={"/sign"}>رایگان شروع کنید</Link>
                    </div>
                  ) : (
                    <div className="landing-fast-start">
                      <Link to={"/sign"}>ورود</Link>
                    </div>
                  )}
                </div>
                <div className="pattern-and-shadow-left">
                  <div>
                    <img src={"/images/svg/right-pattern.svg"} alt="" />
                  </div>
                  <div>
                    <img src={"/images/svg/shadow-right.svg"} alt="" />
                  </div>
                </div>
              </div>
              <div className="header-wrap-left">
                {tmpTheme != 1 ? (
                  <nav className="landing-menu">
                    <Link to="/help">راهنمای استفاده</Link>
                    <Link to="/blog">وبلاگ</Link>
                    <a target="_blank" href="https://shop.talaeshow.com">
                      فروشگاه
                    </a>
                    <Link to="/faq">سوالات متداول</Link>
                    <Link to="/about">درباره ما</Link>
                  </nav>
                ) : (
                  <nav className="landing-menu">
                    <Link to="/rules">قوانین و مقررات</Link>
                  </nav>
                )}
                <img src={"/images/landing-image.jpg"} alt={""} />
              </div>
            </div>
            {tmpTheme != 1 && (
              <div className="mid-main-upper mt-5 ps-5 pe-5 me-5  ">
                <div className="row justify-space-between">
                  <div className="box p-3 col-3">
                    <img
                      className="mb-4"
                      src="images/Users.svg"
                      alt="معامله با قیمت شما"
                    />
                    <span>معامله با قیمت شما</span>
                  </div>
                  <div className="box p-3 col-3">
                    <img
                      className="mb-4"
                      src="images/Equalizer.svg"
                      alt="خرید به میزان دلخواه"
                    />
                    <span>خرید به میزان دلخواه</span>
                  </div>
                  <div className="box p-3 col-3">
                    <img
                      className="mb-4"
                      src="images/Coins.svg"
                      alt={"تضمین عیار"}
                    />
                    <span>تضمین عیار</span>
                  </div>
                  <div className="box p-3 col-3">
                    <img
                      className="mb-4"
                      src="images/ListChecks.svg"
                      alt="واریز و برداشت فوری"
                    />
                    <span>واریز و برداشت فوری</span>
                  </div>
                </div>
              </div>
            )}
          </header>
          {tmpTheme != 1 && (
            <main>
              <div className="mid-main mt-5 ps-5 pe-5 me-5  ">
                <div className="row">
                  <div className="col-5 mt-5 p-3">
                    <div className="price-box-wrapper landing-price">
                      <PriceBox isLanding={true} />
                    </div>
                    <div className="bottom-price-landing-item">
                      <h2>
                        خرید آنلاین طلا و نقره، سرمایه ای مطمئن برای آینده
                      </h2>
                      <div className="bottom-price-description">
                        در طلایی شو، سرمایه گذاری آسان، امن و شفاف را با خرید
                        شمش طلا و نقره تجربه کنید. ذخیره سازی مطمئن و تحویل سریع
                        همراه شما در هر لحظه!
                      </div>
                      <div className="landing-desc-image-item">
                        <img src={"/images/bottom-main-page-desc.png"} />
                      </div>
                    </div>
                  </div>
                  <div className="col-7 mt-5 p-5 pt-0 pb-0">
                    <div className="col-12">
                      <div className="trade-tab row">
                        <div
                          className={
                            active == "buy"
                              ? "tab-item tab-item-active col-6"
                              : "tab-item col-6"
                          }
                          onClick={() => {
                            setamount(null);
                            setGram(0);
                            setSoat(0);
                            setActive("buy");
                          }}
                        >
                          خرید
                        </div>
                        <div
                          className={
                            active == "sell"
                              ? "tab-item tab-item-active col-6"
                              : "tab-item col-6"
                          }
                          onClick={() => {
                            setamount(null);
                            setGram(0);
                            setSoat(0);
                            setActive("sell");
                          }}
                        >
                          فروش
                        </div>
                      </div>
                      <div className="pt-2 pos-rel row border-bottom border-dark mt-3">
                        <input
                          type="number"
                          name="gram"
                          id={"gram"}
                          placeholder={
                            "مقدار " +
                            (Array.isArray(commodities) &&
                            commodities.length > 0
                              ? commodities.find(
                                  (el) => el.id == selectedCommodity.id
                                ) &&
                                commodities.find(
                                  (el) => el.id == selectedCommodity.id
                                ).name
                              : "")
                          }
                          className="calc-input w-100 rounded-top"
                          value={gram != 0 ? gram : ""}
                          onChange={(e) => {
                            setLastChange("gram");
                            handleValueChange(e);
                          }}
                        />
                        <div className="calc-placeholder">
                          {selectedCommodity?.ui_data?.unit_name == null
                            ? "گرم"
                            : selectedCommodity?.ui_data?.unit_name}
                        </div>
                      </div>
                      {selectedCommodity?.ui_data?.unit_name == null && (
                        <div className="pb-2 pos-rel row">
                          <input
                            type="number"
                            name="soat"
                            id={"soat"}
                            className="calc-input w-100 rounded-bottom"
                            placeholder={
                              "مقدار " +
                              (Array.isArray(commodities) &&
                              commodities.length > 0
                                ? commodities.find(
                                    (el) => el.id == selectedCommodity.id
                                  ) &&
                                  commodities.find(
                                    (el) => el.id == selectedCommodity.id
                                  ).name
                                : "")
                            }
                            value={soat != 0 ? parseInt(soat) : ""}
                            onChange={(e) => {
                              setLastChange("soat");
                              handleValueChange(e);
                            }}
                          />
                          <div className="calc-placeholder pb-0">سوت</div>
                        </div>
                      )}
                    </div>
                    <div className="text-center relative mt-3 mb-3 select-margin">
                      <img src="images/ArrowsLeftRight.svg" alt="" />
                      <select
                        name="commodity-type"
                        id={"commodity-type"}
                        className="form-input-gray-custom landing-select-commodity"
                        value={selectedCommodity.id}
                        onChange={(e) => {
                          const selected = commodities.find(
                            (el) => el.id == e.target.value
                          );
                          setSelectedCommodity(selected);
                        }}
                      >
                        {commodities.map((item) => (
                          <option value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="w-100 pos-rel">
                      <input
                        type={"text"}
                        name="price_amount"
                        id={"price_amount"}
                        onChange={(e) => {
                          setLastChange("amount");
                          setamount(
                            parseInt(
                              (e?.target?.value || "").split(",").join("")
                            )
                          );
                        }}
                        value={amount > 0 ? separateNum(amount) : "0"}
                        className="calc-input w-100 rounded"
                      />
                      <div className="calc-placeholder pt-2 pb-0">تومان</div>
                    </div>
                    <button
                      className="btn-submit mt-3 calculate-gold-price"
                      type="button"
                      onClick={handleCalculation}
                    >
                      <h1>محاسبه آنلاین قیمت</h1>
                    </button>
                  </div>
                </div>
                <Products isFull={true} landing={true} />
                <div className="row home-forth-section">
                  <div className="col-7 position-relative">
                    <img
                      src={"/images/sec-4.jpg"}
                      className="sec-image"
                      alt={sellTitle}
                    />
                    <span className="position-absolute dots-left">
                      <img src="images/dots-green.svg" alt="" />
                    </span>
                  </div>
                  <div className="col-4">
                    <h1 className="text-xlarge mb-2">
                      {landingContent.map((item) => {
                        return item.key === "sell_gold_header" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </h1>
                    <h2 className="text-brown mb-3">
                      {landingContent.map((item) => {
                        return item.key === "sell_gold_content" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </h2>
                  </div>
                  <div className="col-1"></div>
                </div>
                <div className="select-box-items">
                  {commodities.map((data) => (
                    <div
                      onClick={() => setSelectedChart(data.id)}
                      className={
                        selectedChart === data.id
                          ? "el-select-box"
                          : "el-select-box active-select-box"
                      }
                    >
                      {data.name}
                    </div>
                  ))}
                </div>
                <div className="chart-on-landing">
                  {chartColor && buyValues && sellValues && (
                    <div className="line-chart-wrapper">
                      <Line
                        height={500}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          scales: {
                            y: {
                              beginAtZero: true,
                            },
                          },
                        }}
                        data={{
                          labels: labels,
                          datasets: [
                            {
                              label: `تاریخچه قیمت ${toPersianNum(
                                (commodities || []).find(
                                  (el) => el.id == selectedChart
                                )?.name
                              )}`,
                              data:
                                activeChart === "buy" ? buyValues : sellValues,
                              borderWidth: 1,
                              borderColor: chartColor,
                              fill: true,
                              pointBackgroundColor: chartColor,
                              backgroundColor: chartColor,
                              tension: 0.4,
                            },
                          ],
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="row sixth-sec">
                  <div className="col-6 p-5 right-side">
                    <h1>
                      {landingContent.map((item) => {
                        return item.key === "buy_gold_header" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </h1>
                    <h2>
                      {landingContent.map((item) => {
                        return item.key === "buy_gold_content" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </h2>
                    <div className="row ps-5 pt-5 text-medium">
                      <Link to={"/sign"}>
                        <button className="btn-start">رایگان شروع کنید</button>
                      </Link>
                    </div>
                  </div>
                  <div className="col-6 sixth-pic">
                    <img src={"/images/sixth-pic.jpg"} alt={buyTitle} />
                  </div>
                </div>
                <div className="row home-third-section">
                  <div className="col-4">
                    <h3 className="text-xlarge mb-4">
                      {landingContent.map((item) => {
                        return item.key === "home_banner_title" ? (
                          <h1>{item.value}</h1>
                        ) : null;
                      })}
                    </h3>
                    <p className="text-brown mb-3">
                      {landingContent.map((item) => {
                        return item.key === "home_banner_content" ? (
                          <h1>{item.value}</h1>
                        ) : null;
                      })}
                    </p>
                  </div>
                  <div className="col-2"></div>
                  <div className="col-6 position-relative">
                    <img
                      src={"/images/sec-3.jpg"}
                      className="sec-image"
                      alt={footerTitle}
                    />
                    <span className="position-absolute dots-right">
                      <img src="images/dots-gold.svg" alt="" />
                    </span>
                  </div>
                </div>
                <span className="video-title">ویدیو آموزشی را ببینید</span>

                <div className="video-wrapper">
                  <div className="iframe-wrapper">
                    <iframe
                      src={iframeLink.split("http").join("https")}
                      allowFullScreen="true"
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                      width={694}
                      height={394}
                    ></iframe>
                  </div>
                </div>
              </div>
              <div className="seventh-sec text-center">
                <div className="users-box pt-2 ms-5">
                  <img src="images/user-box-right.svg" alt="" />
                  <div className="position-relative p-4">
                    <span className="fw-bold d-block mb-4">
                      {" "}
                      {new Intl.NumberFormat("fa").format(usersNumber)}
                    </span>
                    <span className="p-4">کاربر تا امروز</span>
                    <img
                      src="images/+.svg"
                      className="position-absolute bottom-50"
                      alt=""
                    />
                  </div>
                </div>
                <div className="users-box pt-2">
                  <img src="images/user-box-left.svg" alt="" />
                  <div className="position-relative p-4">
                    <span className="fw-bold d-block mb-4">
                      {new Intl.NumberFormat("fa").format(tradesNumber)}
                    </span>
                    <span className="p-4">معامله تا امروز</span>
                    <img
                      src="images/+.svg"
                      className="position-absolute bottom-50"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </main>
          )}
          {tmpTheme == 1 && (
            <>
              <div className={"tmp-theme-bottom-image"}>
                <img src={"/images/bottom-header.jpeg"} />
              </div>
              <div className="middle-row-temp">
                <div className="images-row">
                  <div>
                    <img src={"/images/yellow-gift.jpeg"} />
                  </div>
                  <div>
                    <img src={"/images/pink-gift.jpeg"} />
                  </div>
                  <div>
                    <img src={"/images/purple-gift.jpeg"} />
                  </div>
                </div>
              </div>
              <div className="bottom-middle-row-temp">
                <div className="bottom-images-row">
                  <div>
                    <img src={"/images/bottom-right-gift.jpeg"} />
                  </div>
                  <div>
                    <img src={"/images/bottom-left-gift.png"} />
                  </div>
                </div>
              </div>
            </>
          )}
          <Footer />
        </div>
      )}

      {isTabletOrMobile && (
        <>
          {tmpTheme != 1 && (
            <div className="landing">
              <header className="header-wrap">
                <div className="home-header-menu-mobile">
                  <img src="/images/svg/header-mobile.svg" alt="" />
                </div>
                <div className="landing-logo-mobile">
                  <img src={"/images/svg/landing-logo-mobile.svg"} alt={""} />
                </div>
                <div className="content-for-landing-mobile">
                  <h1 className="title-for-landing-mobile">
                    خرید و فروش شمش طلا و نقره ؛
                    <br />
                    سرمایه گذاری با هر میزان بودجه !
                  </h1>
                  <h1 className="subtitle-for-landing-mobile">
                    خرید شمش
                    <span className="landing-header-gold-color"> طلا </span>
                    و نقره از یک سوت تا چند کیلو
                    <br />
                    بدون حق ضرب و معاف از مالیات
                    <br />
                    <span className="last-line-landing-color">
                      (سرویس خزانه داری، تحویل حضوری و ارسال پستی)
                    </span>
                  </h1>
                </div>
              </header>
              <div className="row pt-2 text-medium text-center">
                <Link to={"/sign"}>
                  <button className="btn-start green-style">
                    رایگان شروع کنید
                  </button>
                </Link>
              </div>
              <nav className="mobile-menu row gx-1">
                <Link className="col-3" to="/faq">
                  سوالات متداول
                </Link>
                <Link className="col-3" to="/about">
                  درباره ما
                </Link>
                <a
                  className="col-3"
                  href="https://shop.talaeshow.com"
                  target="_blank"
                >
                  فروشگاه
                </a>
                <Link className="col-3" to="/help" target="_blank">
                  راهنمای استفاده
                </Link>
              </nav>
              <div className="scroll">
                <div className="info-box-wrapper-mobile-landing">
                  <div className="info-box-mobile">
                    <img
                      src="images/mobile-icon1.svg"
                      className="mobile-icon"
                      alt="تضمین عیار"
                    />
                    <span>تضمین عیار</span>
                  </div>
                  <div className="info-box-mobile">
                    <img
                      src="images/mobile-icon2.svg"
                      className="mobile-icon"
                      alt="از یک سُوت تا چندکیلو"
                    />
                    <span>از یک سُوت تا چندکیلو</span>
                  </div>
                  <div className="info-box-mobile">
                    <img
                      src="images/mobile-icon3.svg"
                      className="mobile-icon"
                      alt="معامله با قیمت شما"
                    />
                    <span>معامله با قیمت شما</span>
                  </div>
                  <div className="info-box-mobile">
                    <img
                      src="images/mobile-icon4.svg"
                      className="mobile-icon"
                      alt="بیمه و انبار امن"
                    />
                    <span>بیمه و انبار امن</span>
                  </div>
                  <div className="info-box-mobile">
                    <img
                      src="images/mobile-icon5.svg"
                      className="mobile-icon"
                      alt="معامله ۲۴ ساعته"
                    />
                    <span>معامله ۲۴ ساعته</span>
                  </div>{" "}
                  <div className="info-box-mobile">
                    <img
                      src="images/mobile-icon6.svg"
                      className="mobile-icon"
                      alt="واریز و برداشت فوری"
                    />
                    <span>واریز و برداشت فوری</span>
                  </div>
                </div>
              </div>
              <div className="green-sec">
                <div>
                  <div className="fw-bold pt-2">
                    {landingContent.map((item) => {
                      return item.key === "buy_gold_header" ? (
                        <>{item.value}</>
                      ) : null;
                    })}
                  </div>
                  <div className="pt-3">
                    {landingContent.map((item) => {
                      return item.key === "buy_gold_content" ? (
                        <>{item.value}</>
                      ) : null;
                    })}
                  </div>
                </div>
                <div className="pic-wrap">
                  <img src="images/pic-green-back-mobile.svg" />
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="padding-pricebox-mobile">
                <PriceBox />
              </div>
              <Products isFull={true} landing={true} />
              <div className="row pt-2 mb-3 text-medium text-center">
                <Link to={"/sign"}>
                  <button className="btn-start">رایگان شروع کنید</button>
                </Link>
              </div>
              <div className="p-2 pt-0">
                <div className="bg-yellow-item">
                  <div className="col-12">
                    <div className="a-title">
                      {landingContent.map((item) => {
                        return item.key === "sell_gold_header" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </div>
                    <div className="b-title">
                      {landingContent.map((item) => {
                        return item.key === "sell_gold_content" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mt-5 p-5 pt-0 pb-0 mobile-calculator-padding">
                <div className="trade-tab row">
                  <div
                    className={
                      active == "buy"
                        ? "tab-item tab-item-active col-6"
                        : "tab-item col-6"
                    }
                    onClick={() => {
                      setamount(null);
                      setGram(0);
                      setSoat(0);
                      setActive("buy");
                    }}
                  >
                    خرید
                  </div>
                  <div
                    className={
                      active == "sell"
                        ? "tab-item tab-item-active col-6"
                        : "tab-item col-6"
                    }
                    onClick={() => {
                      setamount(null);
                      setGram(0);
                      setSoat(0);
                      setActive("sell");
                    }}
                  >
                    فروش
                  </div>
                </div>
                <div className="pt-2 pos-rel row border-bottom border-dark mt-3">
                  <input
                    type="text"
                    name="gram"
                    id={"gram"}
                    placeholder={
                      "مقدار " + toPersianNum(selectedCommodity.name)
                    }
                    className="calc-input w-100 rounded-top"
                    value={gram != 0 ? parseInt(gram) : "0"}
                    onChange={(e) => {
                      setLastChange("gram");
                      handleValueChange(e);
                    }}
                  />
                  <div className="calc-placeholder">
                    {selectedCommodity?.ui_data?.unit_name == null
                      ? "گرم"
                      : selectedCommodity?.ui_data?.unit_name}
                  </div>
                </div>
                {selectedCommodity?.ui_data?.unit_name == null && (
                  <div className="pb-2 pos-rel row">
                    <input
                      type="text"
                      name="soat"
                      id={"soat"}
                      placeholder={
                        "مقدار " +
                        (Array.isArray(commodities) && commodities.length > 0
                          ? commodities.find(
                              (el) => el.id == selectedCommodity.id
                            ) &&
                            commodities.find(
                              (el) => el.id == selectedCommodity.id
                            ).name
                          : "")
                      }
                      className="calc-input w-100 rounded-bottom"
                      value={soat != 0 ? parseInt(soat) : "0"}
                      onChange={(e) => {
                        setLastChange("soat");
                        handleValueChange(e);
                      }}
                    />
                    <div className="calc-placeholder pb-0">سوت</div>
                  </div>
                )}
                <div className="text-center relative mt-3 mb-3 select-margin">
                  <img src="images/ArrowsLeftRight.svg" alt="" />
                  <select
                    name="commodity-type"
                    id={"commodity-type"}
                    className="form-input-gray-custom landing-select-commodity"
                    value={selectedCommodity.id}
                    onChange={(e) => {
                      const selected = commodities.find(
                        (el) => el.id == e.target.value
                      );
                      setSelectedCommodity(selected);
                    }}
                  >
                    {commodities.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
                <div className="w-100 pos-rel">
                  <input
                    type={"text"}
                    name="price_amount"
                    id={"price_amount"}
                    onChange={(e) => {
                      setLastChange("amount");
                      setamount(
                        parseInt(e?.target?.value || "0".split(",").join(""))
                      );
                    }}
                    value={amount > 0 ? separateNum(amount) : "0"}
                    className="calc-input w-100 rounded"
                  />
                  <div className="calc-placeholder pt-2 pb-0">تومان</div>
                </div>
                <button
                  className="btn-submit mt-3"
                  type="button"
                  onClick={handleCalculation}
                >
                  محاسبه کنید
                </button>
              </div>
              <div className="col-12 ps-2">
                <div className="bg-yellow-item">
                  <div className="col-12">
                    <div className="a-title">
                      {" "}
                      {landingContent.map((item) => {
                        return item.key === "home_banner_title" ? (
                          <h1 className="footer-mobile-title">{item.value}</h1>
                        ) : null;
                      })}
                    </div>
                    <div className="b-title">
                      {landingContent.map((item) => {
                        return item.key === "home_banner_content" ? (
                          <h1 className="footer-mobile-content">
                            {item.value}
                          </h1>
                        ) : null;
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mobile-container-video">
                <span className="pb-2 mt-3">ویدیو آموزشی</span>
                <div>
                  <span className="iframe-wrapper">
                    <iframe
                      src="https://www.aparat.com/video/video/embed/videohash/xpfz504/vt/frame?titleShow=true&muted=true&recom=self"
                      allowFullScreen="true"
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                    ></iframe>
                  </span>
                </div>
              </div>
              <div className="seventh-sec text-center">
                <div className="users-box me-2">
                  <img src="images/user-box-right-mobile.svg" alt="" />
                  <div className="position-relative">
                    <span className="fw-bold d-block mb-2 mt-3">
                      {new Intl.NumberFormat("fa").format(usersNumber)}
                    </span>
                    <span className="p-2">کاربر تا امروز</span>
                    <img
                      src="images/+.svg"
                      className="position-absolute bottom-50"
                      alt=""
                    />
                  </div>
                </div>
                <div className="users-box me-2 ms-2 ">
                  <img src="images/user-box-left-mobile.svg" alt="" />
                  <div className="position-relative">
                    <span className="fw-bold d-block mb-2 mt-3">
                      {new Intl.NumberFormat("fa").format(tradesNumber)}
                    </span>
                    <span className="p-2">معامله تا امروز</span>
                    <img
                      src="images/+.svg"
                      className="position-absolute bottom-50"
                      alt=""
                    />
                  </div>
                </div>
              </div>{" "}
              <div className="row pt-2 mb-3 text-medium text-center">
                <Link to={"/sign"}>
                  <button className="btn-start">رایگان شروع کنید</button>
                </Link>
              </div>
            </div>
          )}
          {tmpTheme == 1 && (
            <>
              <div className="mobile-header-tmp">
                <div className="mobile-logo-temp">
                  <img src={"/images/mobile-logo-temp.png"} />
                </div>
                <div className="mobile-header-title">
                  <h1>
                    خرید آنلاین شمش طلا و نقره
                    <br />
                    از طلایی شو
                  </h1>
                </div>
                <div className="tmp-header-image">
                  <img src={"/images/mobile-header.jpeg"} />
                </div>
              </div>
              <div className="tmp-mobile-gift">
                <div>
                  <img src={"/images/purple-gift.jpeg"} />
                </div>
              </div>
              <div className="mobile-bottom-button-row">
                <div>
                  <a
                    href="https://shop.talaeshow.com"
                    className="shop-btn"
                    target="_blank"
                  >
                    مشاهده و خرید
                  </a>
                </div>
              </div>
              <div className="tmp-mobile-gift extra-pad-temp-theme">
                <div>
                  <img src={"/images/bottom-right-gift.jpeg"} />
                </div>
              </div>
              <div className="mobile-bottom-button-row">
                <div>
                  <a
                    href="https://shop.talaeshow.com"
                    className="shop-btn"
                    target="_blank"
                  >
                    مشاهده و خرید
                  </a>
                </div>
              </div>
            </>
          )}
          <Footer />
        </>
      )}
      {showPermissionBtn && (
        <div className="notification-permission-alert">
          <img
            src={"/images/svg/bell.svg"}
            className="bell-icon"
            onClick={() => setActivatePopup(!activatePopup)}
          />
          {activatePopup ? (
            <div className="notification-box-permission">
              <div className="permission-texts">
                <div>
                  از تغییرات لحظه ای قیمت طلا و نقره و جشنواره های ویژه جا
                  نمونید! با فعال کردن دریافت نوتیفیکیشن، همیشه از قیمت لحظه ای
                  طلا و نقره، تخفیف های شگفت انگیز و جدیدترین اطلاع رسانی ها با
                  خبر شوید. همین حالا فعال کنید!
                </div>
                <div>
                  <button
                    className="flex-1"
                    onClick={() => setActivatePopup(false)}
                  >
                    فعلا نه
                  </button>
                  <button className="flex-1" onClick={handlePermissionRequest}>
                    فعال کن
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
}
